import { Graduation } from '@/plugins/api'
import { upsertMany } from '@/helpers'
import { sortBy } from 'lodash'
import moment from 'moment'

export default {
  namespaced: true,
  state: {
    graduations: [],
    isLoading: false
  },
  actions: {
    async fetchGraduations({ commit }, options) {
      const res = await Graduation.fetch({ _sort: 'createdAt:desc', ...options })
      commit('setGraduations', res)
    },
    async fetchGraduation({ commit, state }, { id, options }) {
      const res = await Graduation.fetchOne(id, options)
      commit('setGraduations', upsertMany(state.graduations, res))
    },
    async updateGraduation({ commit, state }, { id, params, options }) {
      const res = await Graduation.update(id, params, options)
      commit(
        'setGraduations',
        sortBy(upsertMany(state.graduations, res), i =>
          moment(i.abortion_date, 'YYYY-MM-DD').unix()
        )
      )
    },
    async createGraduation({ commit, state }, { params, options }) {
      const res = await Graduation.create(params, options)
      commit('setGraduations', upsertMany(state.graduations, res))
    },
    async removeGraduation({ commit, state }, { id, options }) {
      await Graduation.remove(id, options)
      commit(
        'setGraduations',
        state.graduations.filter(i => i.id !== id)
      )
    }
  },
  mutations: {
    setGraduations(state, v) {
      state.graduations = v
    }
  }
}
